var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconGoto = function SvgIconGoto(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#264D6D",
    fillRule: "nonzero",
    d: "M10.818 23.82a.82.82 0 0 0 .818-.818v-3.273a.82.82 0 0 1 .819-.818h12.75l-1.877 1.878a.82.82 0 0 0 0 1.158.845.845 0 0 0 .581.237.815.815 0 0 0 .577-.242l3.273-3.272c.012-.013.02-.025.032-.041a.435.435 0 0 0 .037-.045.673.673 0 0 0 .107-.18s0-.004.004-.004a.783.783 0 0 0 .053-.209c.004-.016.004-.033.004-.049a.745.745 0 0 0-.082-.409l-.024-.045a.893.893 0 0 0-.131-.176l-3.273-3.273a.82.82 0 0 0-1.158 1.158l1.878 1.878H12.455A2.456 2.456 0 0 0 10 19.729v3.273c0 .45.368.818.818.818Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h38v38H0z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconGoto, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-goto.cb712c64.svg";
export { ForwardRef as ReactComponent };